export default __webpack_public_path__ + "static/media/billingFastLogo.fd1294c0.png";